module.exports = __webpack_public_path__ + "static/media/img-msg-save-time.9dcad4e6.png";